/**
 * Settings Module Configuration
 *
 * Provides the Settings overview page and groups
 * Products, API Clients, Users, and other admin areas
 * under one sidebar section.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const settingsModule: AppModule = {
    id: 'settings',

    navigation: {
        label: 'Settings',
        icon: 'settings',
        path: '/settings', // Overview page
        order: 90,


        pages: [
            {
                label: 'Overview',
                path: '/settings',
                icon: 'layout-grid',
                moduleKey: 'settings.overview',
            },
            {
                label: 'API Clients',
                path: '/api-clients',
                icon: 'key',
                moduleKey: 'settings.api_clients',
            },
            {
                label: 'Embed Keys',
                path: '/embed-keys',
                icon: 'code',
                moduleKey: 'settings.embed_keys',
            },
            {
                label: 'Products',
                path: '/products',
                icon: 'package',
                moduleKey: 'settings.products',
            },
            {
                label: 'Users',
                path: '/users',
                icon: 'users',
                moduleKey: 'settings.users',
            },
            {
                label: 'Roles',
                path: '/roles',
                icon: 'shield',
                moduleKey: 'settings.users',
            },
            {
                label: 'Teams',
                path: '/teams',
                icon: 'users-round',
                moduleKey: 'settings.users',
            },
            {
                label: 'Organizations',
                path: '/organizations',
                icon: 'building-2',
                moduleKey: 'settings.organizations',
            },
            {
                label: 'Data Import',
                path: '/imports',
                icon: 'upload',
                moduleKey: 'settings.data_import',
            },
            {
                label: 'Data Cleanup',
                path: '/dedup',
                icon: 'copy-check',
                moduleKey: 'settings.data_cleanup',
            },
            {
                label: 'Integrations',
                path: '/integrations',
                icon: 'plug',
                moduleKey: 'settings.integrations',
            },
            {
                label: 'Workflows',
                path: '/workflows',
                icon: 'git-branch',
                moduleKey: 'settings.workflows',
            },
            {
                label: 'Workers',
                path: '/workers',
                icon: 'activity',
                moduleKey: 'settings.workers',
            },
            {
                label: 'AI Usage',
                path: '/ai-usage',
                icon: 'brain',
                moduleKey: 'settings.ai_usage',
            },
        ],
    },

    routes,
}

export default settingsModule
